import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const ManholeSalesDashboardRoute: RouteType = {
  name: "Manhole Sales Dashboard",
  path: "/manhole-sales",
  layout: "/app",
  group: "Sales",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Manhole Sales Dashboard",
      component: () => import("./ManholeSalesDashboard.Header"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./ManholeSalesDashboard.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Initialize the dashboard view store
      const ManholeSalesDashboardViewStore = (
        await import("./stores/ManholeSalesDashboardViewStore")
      ).default;

      if (!rootStore.manholeSalesDashboardViewStore) {
        rootStore.manholeSalesDashboardViewStore =
          new ManholeSalesDashboardViewStore(rootStore);
      }

      // Load critical sales stores
      const promises = [];

      // Load sales orders
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;
      if (salesOrdersStore) {
        promises.push(salesOrdersStore.find());
      }

      // Load sales order lines
      const salesOrderLinesStore = rootStore.salesOrderLinesStore as ServiceStore;
      if (salesOrderLinesStore) {
        promises.push(salesOrderLinesStore.find());
      }

      // Load manhole quotes for linking
      const manholeQuotesStore = rootStore.manholeQuotesStore as ServiceStore;
      if (manholeQuotesStore) {
        promises.push(manholeQuotesStore.find());
      }

      // Load customers for display
      const customersStore = rootStore.customersStore as ServiceStore;
      if (customersStore) {
        promises.push(customersStore.find());
      }

      // Load projects for context
      const projectsStore = rootStore.projectsStore as ServiceStore;
      if (projectsStore) {
        promises.push(projectsStore.find());
      }

      // Execute all data loading in parallel
      await Promise.allSettled(promises);

      // Load dashboard data after stores are populated
      const viewStore = (rootStore as any).manholeSalesDashboardViewStore;
      if (viewStore) {
        await viewStore.loadDashboardData();
      }

      return true;
    } catch (error) {
      console.error("Failed to load manhole sales dashboard data:", error);
      return true; // Allow navigation even if data loading fails
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).manholeSalesDashboardViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default ManholeSalesDashboardRoute;
